import React, { useEffect, useState } from 'react';
import classes from './CookieBanner.module.scss';
import { Link } from 'react-router-dom';

function CookieBanner () {
    const [visible, setVisible] = useState(false);

    function setCookie (name, value, days) {
        const expires = new Date();

        expires.setTime(
            expires.getTime() + days * 24 * 60 * 60 * 1000
        );

        document.cookie =
            `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
    }

    function getCookie (name) {
        return document.cookie
            .split('; ')
            .find(row => row.startsWith(name + '='))
            ?.split('=')[1];
    }

    useEffect(() => {
        const accepted = getCookie('cookiesAccepted');

        if (accepted !== 'true') {
            setVisible(true);
        }
    }, []);

    function handleAccept () {
        setCookie(
            'cookiesAccepted',
            'true',
            365
        );

        setVisible(false);
    }

    if (!visible) {
        return null;
    }

    return (
        <div className={classes.cookieBanner}>
            <div className={classes.cookieContent}>
                <p className={classes.cookieText}>
ООО «Поинтс Лабс» использует cookie-файлы для сбора информации об использовании сайта посетителями,
что способствует эффективному функционированию сайта.<br/>
Нажимая кнопку «Я согласен» или продолжая использовать сайт,
вы соглашаетесь на обработку своих персональных данных на условиях,
указанных в <Link to="/docs/policy">Политике обработки персональных данных</Link>.<br/>
Вы можете отключить cookie-файлы в вашем браузере.<br/>
                </p>
            </div>

            <div className={classes.cookieActions}>
                <button
                    className={classes.acceptButton}
                    onClick={handleAccept}
                >
                    Я согласен
                </button>
            </div>
        </div>
    );
}

export default CookieBanner;
